<template>
  <div>
    <v-card-title class="headline">Nutzungsvereinbarung:</v-card-title>
    <v-card-text>
      <p>
        In den nachfolgenden Dokumenten finden Sie Hinweise zu den Nutzungsvoraussetzungen, zur Vorgehensweise bei der
        Beantragung des Zugangs sowie zur Bereitstellung der Daten.
        <a :href="termOfUseDownload" target="_blank">Nutzung des Downloadbereichs für wasserwirtschaftliche Daten</a>
      </p>
      <span>Anlagen:</span>
      <ul>
        <li>
          <a :href="termOfUseWM" target="_blank">Bedingungen für die Nutzung des Downloadbereichs Wasserwirtschaft</a>
        </li>
        <li>
          <a :href="termOfUseWRRL" target="_blank"
            >Nutzungsvereinbarung für ein Mitglied von WRRL-Kooperationen, das keine öffentlich rechtlichen Aufgaben der
            Wasserwirtschaft wahrnimmt</a
          >
        </li>
        <li>
          <a :href="liabilities" target="_blank">Verpflichtung eines Auftragnehmers</a>
        </li>
        <li>
          <a :href="activationOrder" target="_blank">Freischaltungsauftrag an das LANUV für einen Auftragnehmer</a>
        </li>
      </ul>
    </v-card-text>
  </div>
</template>
<script>
export default {
  computed: {
    termOfUseDownload() {
      return `./docs/Nutzung_Downloadbereich.pdf`;
    },
    termOfUseWM() {
      return `./docs/Nutzungsbedingungen.pdf`;
    },
    termOfUseWRRL() {
      return `./docs/Nutzungsvereinbarung_Mitglieder_WRRL-Kooperationen.pdf`;
    },
    liabilities() {
      return `./docs/Auftragnehmerverpflichtung.pdf`;
    },
    activationOrder() {
      return `./docs/Freischaltung_Auftragnehmer.pdf`;
    }
  }
};
</script>
